import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
import {
	Fancybox
} from "@fancyapps/ui";

import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});

import Swiper from 'swiper/bundle';
exports.swiper = Swiper;


/* GSAP */
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { ScrollSmoother } from "gsap/all";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";

gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin, ScrollSmoother, SplitText);

window.gsap = gsap;

AOS.init({
	once: true,
	duration: 800, // values from 0 to 3000, with step 50ms
	easing: 'ease-in-out',
	initClassName: false,
	offset: 150
});

Fancybox.bind("[data-fancybox]", {
	hideScrollbar: true,
});

jQuery(function ($) {
	$(document).on('change', 'input[name="category"]', function () {
		$(this).closest('form').trigger('submit');
	})

	$('#filter-form').on('submit', function (event) {
		event.preventDefault();
		var formData = $(this).serialize();

		$.ajax({
			url: gettonetAjax.ajaxurl, // The WordPress AJAX handler
			data: formData,
			dataType: 'json',
			type: 'POST',
			beforeSend: function () {
				$('#gettonet_posts_wrap').addClass('loading');
			},
			success: function (data) {
				// when filter applied:
				// set the current page to 1
				gettonetAjax.current_page = 1;

				// set the new query parameters
				gettonetAjax.posts = data.posts;

				// set the new max page parameter
				gettonetAjax.max_page = data.max_page;



				$('#gettonet_posts_wrap').removeClass('loading').html(data.content);
				// hide load more button, if there are not enough posts for the second page
				if (data.max_page < 2) {
					$('#gettonet_loadmore').hide();
				} else {
					$('#gettonet_loadmore').show();
				}
			},
			error: function (xhr, status, error) {
				$('#gettonet_posts_wrap').html('<p>Error occurred. Please try again later.</p>');
				console.log(xhr.responseText);
			}
		});
	});

	/*
	 * Load More
	 */
	$('#gettonet_loadmore').click(function () {

		$.ajax({
			url: gettonetAjax.ajaxurl, // AJAX handler
			data: {
				'action': 'loadmorebutton', // the parameter for admin-ajax.php
				'query': gettonetAjax.posts, // loop parameters passed by wp_localize_script()
				'page': gettonetAjax.current_page // current page
			},
			type: 'POST',
			beforeSend: function (xhr) {
				$('#gettonet_loadmore').text('Loading...'); // some type of preloader
			},
			success: function (posts) {
				if (posts) {
					//console.log(posts);
					$('#gettonet_loadmore').text('More posts');
					$('#gettonet_posts_wrap').append(posts); // insert new posts
					gettonetAjax.current_page++;

					if (gettonetAjax.current_page == gettonetAjax.max_page)
						$('#gettonet_loadmore').hide(); // if last page, HIDE the button

				} else {
					$('#gettonet_loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});
});



function initializeObserver() {
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('visible');
				observer.unobserve(entry.target);
			}
		});
	});

	const images = document.querySelectorAll('.popup-box');


	images.forEach(img => {
		// img.classList.remove('popup-box');
		observer.observe(img);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initializeObserver();
});



// custom-javascript.js
(function () {
	let split = null;
	let tl = null;

	function initTextAnimation() {
		const createSplit = () => {
			if (split) split.revert();
			if (tl) tl.revert();

			// Initialize SplitText to split by lines and optionally characters
			split = new SplitText("#nas-moto #wrapper h2", {
				type: "lines, chars" // Split into lines and characters within lines
			});

			// Wrap each line in a div for better control (SplitText does this automatically)
			gsap.set(split.lines, {
				position: "relative",
				overflow: "hidden" // Helps with animation effects
			});

			// Create the timeline with ScrollTrigger
			tl = gsap.timeline({
				scrollTrigger: {
					trigger: "#nas-moto",
					start: "top top",
					end: "+=150%",
					pin: true,
					scrub: 0.75,
					markers: false
				}
			});

			// Animate each line
			tl.from(split.lines, {
				y: 100,           // Slide up from below (adjust as needed)
				opacity: 0,       // Fade in
				duration: 0.5,    // Duration per line
				stagger: 0.2,     // Delay between each line's animation
				ease: "power2.out"
			})
				.to(split.chars, {
					color: "#212529", // Color change for characters
					stagger: 0.05,    // Stagger character color change within lines
					duration: 0.3
				}, "-=0.3"); // Overlap with line animation for smoother transition
		};

		if (document.querySelector("#nas-moto #wrapper h2")) {
			gsap.registerPlugin(ScrollTrigger, SplitText);
			createSplit();
		} else {
			console.warn("H2 in #nas-moto #wrapper not found");
			return null;
		}

		const debouncer = gsap.delayedCall(0.2, createSplit).pause();
		const handleResize = () => debouncer.restart(true);
		window.addEventListener("resize", handleResize);

		const destroy = () => {
			if (split) split.revert();
			if (tl) tl.kill();
			window.removeEventListener("resize", handleResize);
			debouncer.kill();
		};

		return { destroy, refresh: createSplit };
	}

	window.initTextAnimation = initTextAnimation;

	document.addEventListener("DOMContentLoaded", function () {
			window.initTextAnimation();
	});
})();

// custom-javascript.js
(function () {
	let split = null;
	let tl = null;

	function headingAmination() {
		const createSplit = () => {
			if (split) split.revert();
			if (tl) tl.revert();

			// Split text into words
			split = new SplitText(".animated-h1", { type: "words" });

			// Ensure the h1 is centered and initially hidden
			gsap.set(".animated-h1", {
				position: "relative",
				display: "inline-block",
				textAlign: "center",
				width: "100%",
				opacity: 0,        // Ensure hidden
				visibility: "hidden" // Prevent interaction
			});

			// Set initial positions
			gsap.set(split.words[0], { x: "-100vw" }); // "Vikendica" from left
			gsap.set(split.words[1], { x: "100vw" });  // "Ristic" from right

			// Create timeline for animation
			tl = gsap.timeline({ delay: 0.7 }) // Slight delay on page load     
				.to(".animated-h1", {
					opacity: 1,
					visibility: "visible",
					duration: 0.1
				}, 0)
				// Animate "Vikendica" from left
				.to(split.words[0], {
					x: 0,
					duration: 1.2,
					ease: "power2.out"
				}, 0.1)

				.to(split.words[1], {
					x: 0,
					duration: 1.2,
					ease: "power2.out"
				}, 0.1);
		};

		if (document.querySelector(".animated-h1")) {
			gsap.registerPlugin(SplitText);
			createSplit();
		} else {
			console.warn("H1 with class 'animated-h1' not found");
			return null;
		}

		const debouncer = gsap.delayedCall(0.2, createSplit).pause();
		const handleResize = () => debouncer.restart(true);
		window.addEventListener("resize", handleResize);

		const destroy = () => {
			if (split) split.revert();
			if (tl) tl.kill();
			window.removeEventListener("resize", handleResize);
			debouncer.kill();
		};

		return { destroy, refresh: createSplit };
	}

	window.headingAmination = headingAmination;

	document.addEventListener("DOMContentLoaded", function () {
			window.headingAmination();
	});
})();

/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
 - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
 - When each item animates to the left or right enough, it will loop back to the other side
 - Optionally pass in a config object with values like draggable: true, center: true, speed (default: 1, which travels at roughly 100 pixels per second), paused (boolean), repeat, reversed, and paddingRight.
 - The returned timeline will have the following methods added to it:
   - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
   - current() - returns the current index (if an animation is in-progress, it reflects the final index)
   - times - an Array of the times on the timeline where each element hits the "starting" spot.
 */
   (function () {
	function horizontalLoop(items, config) {
		items = gsap.utils.toArray(items);
		config = config || {};
		let onChange = config.onChange,
			lastIndex = 0,
			tl = gsap.timeline({
				repeat: config.repeat, onUpdate: onChange && function () {
					let i = tl.closestIndex();
					if (lastIndex !== i) {
						lastIndex = i;
						onChange(items[i], i);
					}
				}, paused: config.paused, defaults: { ease: "none" }, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
			}),
			length = items.length,
			startX = items[0].offsetLeft,
			times = [],
			widths = [],
			spaceBefore = [],
			xPercents = [],
			curIndex = 0,
			indexIsDirty = false,
			center = config.center,
			pixelsPerSecond = (config.speed || 1) * 100,
			snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
			timeOffset = 0,
			container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
			totalWidth,
			getTotalWidth = () => items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + spaceBefore[0] + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0),
			populateWidths = () => {
				let b1 = container.getBoundingClientRect(), b2;
				items.forEach((el, i) => {
					widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
					xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / widths[i] * 100 + gsap.getProperty(el, "xPercent"));
					b2 = el.getBoundingClientRect();
					spaceBefore[i] = b2.left - (i ? b1.right : b1.left);
					b1 = b2;
				});
				gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
					xPercent: i => xPercents[i]
				});
				totalWidth = getTotalWidth();
			},
			timeWrap,
			populateOffsets = () => {
				timeOffset = center ? tl.duration() * (container.offsetWidth / 2) / totalWidth : 0;
				center && times.forEach((t, i) => {
					times[i] = timeWrap(tl.labels["label" + i] + tl.duration() * widths[i] / 2 / totalWidth - timeOffset);
				});
			},
			getClosest = (values, value, wrap) => {
				let i = values.length,
					closest = 1e10,
					index = 0, d;
				while (i--) {
					d = Math.abs(values[i] - value);
					if (d > wrap / 2) {
						d = wrap - d;
					}

					if (d < closest) {
						closest = d;
						index = i;
					}
				}

				return index;
			},
			populateTimeline = () => {
				let i, item, curX, distanceToStart, distanceToLoop;
				tl.clear();
				for (i = 0; i < length; i++) {
					item = items[i];
					curX = xPercents[i] / 100 * widths[i];
					distanceToStart = item.offsetLeft + curX - startX + spaceBefore[0];
					distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
					tl.to(item, { xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond }, 0)
						.fromTo(item, { xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100) }, { xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false }, distanceToLoop / pixelsPerSecond)
						.add("label" + i, distanceToStart / pixelsPerSecond);
					times[i] = distanceToStart / pixelsPerSecond;
				}

				timeWrap = gsap.utils.wrap(0, tl.duration());
			},
			refresh = (deep) => {
				let progress = tl.progress();
				tl.progress(0, true);
				populateWidths();
				deep && populateTimeline();
				populateOffsets();
				deep && tl.draggable ? tl.time(times[curIndex], true) : tl.progress(progress, true);
			},
			proxy;
		gsap.set(items, { x: 0 });
		populateWidths();
		populateTimeline();
		populateOffsets();
		window.addEventListener("resize", () => refresh(true));
		function toIndex(index, vars) {
			vars = vars || {};
			(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
			let newIndex = gsap.utils.wrap(0, length, index),
				time = times[newIndex];
			if (time > tl.time() !== index > curIndex && index !== curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
				time += tl.duration() * (index > curIndex ? 1 : -1);
			}

			if (time < 0 || time > tl.duration()) {
				vars.modifiers = { time: timeWrap };
			}

			curIndex = newIndex;
			vars.overwrite = true;
			gsap.killTweensOf(proxy);
			return vars.duration === 0 ? tl.time(timeWrap(time)) : tl.tweenTo(time, vars);
		}

		tl.toIndex = (index, vars) => toIndex(index, vars);
		tl.closestIndex = setCurrent => {
			let index = getClosest(times, tl.time(), tl.duration());
			if (setCurrent) {
				curIndex = index;
				indexIsDirty = false;
			}

			return index;
		};
		tl.current = () => indexIsDirty ? tl.closestIndex(true) : curIndex;
		tl.next = vars => toIndex(tl.current() + 1, vars);
		tl.previous = vars => toIndex(tl.current() - 1, vars);
		tl.times = times;
		tl.progress(1, true).progress(0, true); // pre-render for performance
		if (config.reversed) {
			tl.vars.onReverseComplete();
			tl.reverse();
		}

		if (config.draggable && typeof (Draggable) === "function") {
			proxy = document.createElement("div")
			let wrap = gsap.utils.wrap(0, 1),
				ratio, startProgress, draggable, dragSnap, lastSnap, initChangeX,
				align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
				syncIndex = () => tl.closestIndex(true);
			typeof (InertiaPlugin) === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
			draggable = Draggable.create(proxy, {
				trigger: items[0].parentNode,
				type: "x",
				onPressInit() {
					let x = this.x;
					gsap.killTweensOf(tl);
					startProgress = tl.progress();
					refresh();
					ratio = 1 / totalWidth;
					initChangeX = (startProgress / -ratio) - x;
					gsap.set(proxy, { x: startProgress / -ratio });
				},
				onDrag: align,
				onThrowUpdate: align,
				overshootTolerance: 0,
				inertia: true,
				snap(value) {
					//note: if the user presses and releases in the middle of a throw, due to the sudden correction of proxy.x in the onPressInit(), the velocity could be very large, throwing off the snap. So sense that condition and adjust for it. We also need to set overshootTolerance to 0 to prevent the inertia from causing it to shoot past and come back
					if (Math.abs(startProgress / -ratio - this.x) < 10) {
						return lastSnap + initChangeX
					}

					let time = -(value * ratio) * tl.duration(),
						wrappedTime = timeWrap(time),
						snapTime = times[getClosest(times, wrappedTime, tl.duration())],
						dif = snapTime - wrappedTime;
					Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
					lastSnap = (time + dif) / tl.duration() / -ratio;
					return lastSnap;
				},
				onRelease() {
					syncIndex();
					draggable.isThrowing && (indexIsDirty = true);
				},
				onThrowComplete: syncIndex
			})[0];
			tl.draggable = draggable;
		}

		tl.closestIndex(true);
		lastIndex = curIndex;
		onChange && onChange(items[curIndex], curIndex);
		return tl;
	}

	window.horizontalLoop = horizontalLoop;
})();
